import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-search-box-page-ui',
    templateUrl: './bb-search-box-page-ui.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class BbSearchBoxPageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
